var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root seniority-chart"},[_vm._l((_vm.levels),function(level){return [_c('LevelBar',{key:level.label,staticClass:"bar",attrs:{"level":level,"totalMax":_vm.totalMax}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }